var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"clipped":"","fixed":"","id":"sidebar"}},[_c('div',{staticClass:"inner"},[_c('nav',[_c('ul',_vm._l((_vm.items),function(item){return _c('li',{key:item.title},[_c('a',{staticClass:"scrolly",class:{
              active: _vm.getClass(item),
            },attrs:{"href":item.link}},[_vm._v(_vm._s(item.title))])])}),0)])])])}
var staticRenderFns = []

export { render, staticRenderFns }